import { redraw, } from 'mithril';
import BaseClass from 'application/BaseClass';


export default class BaseVm extends BaseClass {

  constructor(options = {}){
    super(options);
    const { store, stores, blockName, } = this.options;
    Object.assign(this, { blockName, });
    if (stores || store) {
      if (store) {
        const singleStoreName = store.constructor.name.replace(/^./, match => match.toLowerCase());
        this.stores = {
          [singleStoreName]: store,
        };
      } else {
        this.stores = stores;
      }
      this.addStoresChangeListeners();
    }
  }

  addStoresChangeListeners(){
    Object
      .keys(this.stores)
      .forEach(this.addStoreChangeListenerByStoreName, this);
    return this;
  }

  addStoreChangeListenerByStoreName(storeName){
    return this.addStoreChangeListener(this.stores[storeName]);
  }

  addStoreChangeListener(store){
    // required for mocks
    store && store.addChangeListener instanceof Function && store.addChangeListener(this.onChange.bind(this));
    return this;
  }

  get store(){
    return this.stores[Object.keys(this.stores)[0]];
  }

  get state(){
    const { store, state, } = this.options;
    return store && store.state || state || {};
  }

  onChange(){
    redraw();
    return this;
  }

}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/vms/BaseVm.js